function getFlairPriceText(price) {
    if (price && _.get(price, 'length', 0) === 2) {
        return price[0] + '€ - ' + price[1] + '€';
    }
    return '';
}

const data = () => ({
    store: $store,
});

export default {
    data,
    methods: {
        getFlairPriceText,
    },
}
